/* Sign-up pop-up (sections/signup-popup-001.liquid).
   Opens once after the set seconds of looking at the shop for shoppers who have not signed up (see "when to open"),
   comes back after the set number of days when
   closed, never again after signing up. The email goes to the Klaviyo list from the theme editor (Klaviyo's public
   sign-up address, the one their own forms use), then the code shows. The Klaviyo pop-ups it replaces are closed
   with their own close button, so Klaviyo frees the page scroll and waits its usual time before asking again. */
(function () {
  'use strict';
  if (window.fiboliSignup) return;
  var KEY = 'fiboliSignup:v1', DAY = 864e5;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var el = {}, cfg = {}, st = { open: false, step: '', lastFocus: null, timer: 0, savedY: 0, sending: false, selected: false, picked: false };

  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } };
  var write = function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
  var teaserOff = function () { try { return sessionStorage.getItem(KEY + ':teaser') === 'off'; } catch (e) { return false; } };
  var isEmail = function (v) { return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(v); };
  var deviceOk = function () { var wide = window.matchMedia('(min-width: 750px)').matches; return cfg.devices === 'phone' ? !wide : cfg.devices === 'computer' ? wide : true; };

  /* ---------- pictures: a fresh random pick each time it opens ---------- */
  function choosePics() {
    var all = (cfg.pics || []).slice();
    for (var i = all.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = all[i]; all[i] = all[j]; all[j] = t; }
    var set = function (img, p) { if (!img || !p) return; img.sizes = p.own ? '(min-width: 750px) 560px, 92vw' : '160px'; img.srcset = p.srcset; img.src = p.src; img.width = p.w; img.height = p.h; };
    if (el.art) { el.art.hidden = !all.length || cfg.style !== 'pouch'; el.art.classList.toggle('is-own', !!(all[0] && all[0].own)); set(el.art.querySelector('img'), all[0]); }
    if (el.duo) { var imgs = el.duo.querySelectorAll('img'); el.duo.hidden = !all.length; set(imgs[0], all[0]); set(imgs[1], all[1]); imgs[1].hidden = !all[1]; }
  }

  /* ---------- steps, open, close ---------- */
  function show(step) {
    st.step = step;
    el.root.querySelectorAll('[data-step]').forEach(function (n) { n.hidden = n.getAttribute('data-step') !== step; });
    el.card.setAttribute('aria-labelledby', 'sp1-h-' + step);
    el.root.setAttribute('data-at', step);
  }
  function lockPage(on) {
    var b = document.body.style;
    if (on) { st.savedY = window.scrollY; b.position = 'fixed'; b.top = -st.savedY + 'px'; b.left = '0'; b.right = '0'; b.overflowY = 'scroll'; return; }
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.overflowY = ''; window.scrollTo(0, st.savedY);
  }
  function open(step) {
    if (st.open || !el.root) return;
    clearTimeout(st.timer);
    if (window.FiboliMenu) window.FiboliMenu.close(false);
    /* the first opening uses the pictures picked (and loaded) during the wait; a reopening picks new ones */
    if (st.picked) st.picked = false; else choosePics();
    show(step || (cfg.style === 'steps' ? 'ask' : 'form'));
    st.lastFocus = document.activeElement; st.open = true;
    el.root.hidden = false; lockPage(true);
    if (el.teaser) el.teaser.hidden = true;
    requestAnimationFrame(function () { el.root.classList.add('is-open'); el.card.focus({ preventScroll: true }); });
  }
  function close() {
    if (!st.open) return;
    st.open = false; el.root.classList.remove('is-open'); el.root.hidden = true; lockPage(false);
    var o = read(), done = st.step === 'done' || !!o.done;
    if (!editor && !done) { o.closed = Date.now(); write(o); }
    if (!editor && !done) showTeaser();
    if (st.lastFocus && st.lastFocus.focus && document.contains(st.lastFocus)) st.lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (!st.open) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = Array.prototype.filter.call(el.card.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'), function (n) { return !n.disabled && !n.closest('[hidden]') && n.getClientRects().length; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1], a = document.activeElement;
    if (!el.card.contains(a) || a === el.card || a.getAttribute('tabindex') === '-1') { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- sign-up ---------- */
  function say(text) {
    el.msg.textContent = text || ''; el.msg.hidden = !text;
    if (text) el.input.setAttribute('aria-invalid', 'true'); else el.input.removeAttribute('aria-invalid');
  }
  function send(email) {
    var body = { data: { type: 'subscription', attributes: { custom_source: cfg.kl.source || 'Website pop-up', profile: { data: { type: 'profile', attributes: { email: email, locale: cfg.kl.locale, properties: { $source: cfg.kl.source }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: cfg.kl.list } } } } };
    var ctl = window.AbortController ? new AbortController() : null, t = ctl ? setTimeout(function () { ctl.abort(); }, 15000) : 0;
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.kl.key), {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined
    }).then(function (r) { clearTimeout(t); if (!r.ok) throw new Error('status ' + r.status); }, function (err) { clearTimeout(t); throw err; });
  }
  function onSubmit(e) {
    e.preventDefault();
    if (st.sending) return;
    var email = el.input.value.trim();
    if (!isEmail(email)) { say(cfg.t.error); el.input.focus(); return; }
    say('');
    if (editor) { done(); return; }
    st.sending = true; el.submit.disabled = true; el.submit.classList.add('is-loading'); el.submit.setAttribute('aria-busy', 'true');
    send(email).then(function () {
      write({ done: Date.now() });
      /* tell Klaviyo's own script who this is, like its forms do, so it does not ask again either */
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (x) {}
      done();
    }, function () { say(cfg.t.failed); }).then(function () {
      st.sending = false; el.submit.disabled = false; el.submit.classList.remove('is-loading'); el.submit.removeAttribute('aria-busy');
    });
  }
  function done() { show('done'); var h = el.root.querySelector('#sp1-h-done'); if (h) h.focus({ preventScroll: true }); }
  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-sp1-close]')) { e.preventDefault(); close(); return; }
    if (t.closest('[data-sp1-yes]')) { e.preventDefault(); show('form'); el.input.focus(); return; }
    var c = t.closest('[data-sp1-copy]');
    if (c) {
      var code = el.root.querySelector('[data-sp1-code]'), text = code ? code.textContent.trim() : '';
      var pick = function () { if (!code || !window.getSelection) return; var r = document.createRange(); r.selectNodeContents(code); var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); };
      try { navigator.clipboard.writeText(text).then(function () { c.textContent = cfg.t.copied; }, pick); } catch (x) { pick(); }
    }
  }

  /* ---------- the small reminder button ---------- */
  function showTeaser() { if (!el.teaser || teaserOff() || !deviceOk()) return; el.teaser.hidden = false; liftTeaser(); }
  function liftTeaser() {
    if (!el.teaser || el.teaser.hidden) return;
    /* on product pages the sticky Add to cart bar sits at the bottom: stay above it */
    var bar = document.querySelector('[id^="fiboli-sticky-cta-"].is-visible'), h = bar ? bar.getBoundingClientRect().height : 0;
    el.teaser.style.bottom = 'calc(' + (h ? Math.round(h) + 10 : 16) + 'px + env(safe-area-inset-bottom, 0px))';
  }
  function onTeaser(e) {
    if (e.target.closest('[data-sp1-teaser-hide]')) { el.teaser.hidden = true; try { sessionStorage.setItem(KEY + ':teaser', 'off'); } catch (x) {} return; }
    if (e.target.closest('[data-sp1-teaser-open]')) open();
  }
  var raf = 0;
  window.addEventListener('scroll', function () { if (raf || !el.teaser || el.teaser.hidden) return; raf = requestAnimationFrame(function () { raf = 0; liftTeaser(); }); }, { passive: true });

  /* ---------- the Klaviyo pop-ups this one replaces ---------- */
  /* Klaviyo says "open" a moment before its pop-up takes a press, and it only takes a full press (pointer down, up,
     click) on a laid-out button: so the pop-up is made invisible (not removed) and its close button is pressed until
     Klaviyo says "close". Klaviyo then forgets to unlock the page (it waits for its own fade), so the lock goes too. */
  var klShut = {};
  function press(b) {
    var r = b.getBoundingClientRect(), o = { bubbles: true, cancelable: true, composed: true, clientX: r.left + r.width / 2, clientY: r.top + r.height / 2, button: 0, pointerId: 1, pointerType: 'mouse', isPrimary: true };
    var P = window.PointerEvent || MouseEvent;
    b.dispatchEvent(new P('pointerdown', o)); b.dispatchEvent(new MouseEvent('mousedown', o));
    b.dispatchEvent(new P('pointerup', o)); b.dispatchEvent(new MouseEvent('mouseup', o)); b.dispatchEvent(new MouseEvent('click', o));
  }
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {}, ids = (cfg.kl && cfg.kl.replace) || [];
    if (!el.root || ids.indexOf(d.formId) < 0) return;
    if (d.type === 'open') {
      document.documentElement.classList.add('sp1-kl-off');
      var tries = 0, dlg = null; clearTimeout(klShut[d.formId]);
      (function shut() {
        dlg = document.querySelector('[aria-label="POPUP Form"]:not([data-sp1-off])') || document.querySelector('[aria-label="POPUP Form"]');
        var x = dlg && (dlg.querySelector('button[aria-label="Close dialog"]') || dlg.querySelector('button'));
        if (dlg) dlg.setAttribute('data-sp1-off', '');
        if (x) press(x);
        if (++tries < 60) { klShut[d.formId] = setTimeout(shut, 250); return; }
        /* safety net: Klaviyo did not close it in 15 s, so show it again; the visitor closes it as before, the page
           is never left locked behind an invisible pop-up */
        document.documentElement.classList.remove('sp1-kl-off');
        if (dlg) dlg.removeAttribute('data-sp1-off');
      })();
    } else if (d.type === 'close') {
      clearTimeout(klShut[d.formId]);
      setTimeout(function () {
        document.documentElement.classList.remove('sp1-kl-off');
        var other = Array.prototype.some.call(document.querySelectorAll('[aria-label="POPUP Form"]:not([data-sp1-off])'), function (n) { return getComputedStyle(n).display !== 'none' && n.getBoundingClientRect().height > 0; });
        if (!other) document.body.classList.remove('klaviyo-prevent-body-scrolling');
      }, 400);
    }
  });

  /* ---------- when to open: after the set seconds of the shopper looking at the shop in this visit (earlier pages add
     up, a hidden tab does not count); on computers also when the mouse heads for the tabs to leave. A shopper who is
     busy is never interrupted: cart or menu open, typing in a field, or a cart change in the last 20 s ---------- */
  var SEEN = KEY + ':seen', lastCart = 0, cartCount = null;
  /* the cart reports itself on every page load too: only a change in what is in it, or closing it, counts */
  document.addEventListener('cart:inventory:sync', function (e) {
    var n = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
    if (n === null) return;
    if (cartCount !== null && n !== cartCount) lastCart = Date.now();
    cartCount = n;
  });
  var cartEl = document.getElementById('cart-popup-main-003');
  var cartWasOpen = false;
  if (cartEl && window.MutationObserver) new MutationObserver(function () {
    var openNow = cartEl.getAttribute('aria-hidden') === 'false';
    if (cartWasOpen && !openNow) lastCart = Date.now();
    cartWasOpen = openNow;
  }).observe(cartEl, { attributes: true, attributeFilter: ['aria-hidden'] });
  function busyElsewhere() {
    var cart = document.getElementById('cart-popup-main-003'), a = document.activeElement;
    var typing = !!(a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable) && !(el.root && el.root.contains(a)));
    return (cart && cart.getAttribute('aria-hidden') === 'false') || !!document.querySelector('.fiboli-mobile-drawer.active') || typing || Date.now() - lastCart < 20000;
  }
  function seen() { try { return parseInt(sessionStorage.getItem(SEEN), 10) || 0; } catch (e) { return 0; } }
  function startClock() {
    var need = Math.max(0, cfg.delay || 0) * 1000, ms = seen();
    var tick = function () {
      if (!document.hidden) { ms += 500; try { sessionStorage.setItem(SEEN, String(ms)); } catch (e) {} }
      if (ms >= need) { clearInterval(st.timer); tryOpen(); }
    };
    st.timer = setInterval(tick, 500);
    if (cfg.exitIntent && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function leave(e) {
        if (e.relatedTarget || e.clientY > 0 || ms < 3000) return;
        document.removeEventListener('mouseout', leave); clearInterval(st.timer); tryOpen();
      });
    }
  }
  /* already on the list: a signed-in customer who accepts emails, or a visitor Klaviyo already knows */
  function known() {
    if (cfg.known) return Promise.resolve(true);
    if (!cfg.skipKnown || !window.klaviyo || !window.klaviyo.isIdentified) return Promise.resolve(false);
    return new Promise(function (res) {
      var t = setTimeout(function () { res(false); }, 1500);
      try { window.klaviyo.isIdentified().then(function (v) { clearTimeout(t); res(!!v); }, function () { clearTimeout(t); res(false); }); } catch (x) { clearTimeout(t); res(false); }
    });
  }
  function due() { var o = read(); return !o.done && deviceOk() && !(o.closed && Date.now() - o.closed < (cfg.again || 1) * DAY); }
  function tryOpen() {
    if (st.open) return;
    if (busyElsewhere()) { st.timer = setTimeout(tryOpen, 4000); return; }
    known().then(function (k) { if (!k && due() && !st.open) open(); });
  }

  /* ---------- wiring (again after the theme editor redraws the section) ---------- */
  function bind() {
    var root = document.getElementById('signup-popup-001'), conf = document.getElementById('sp1-config');
    if (!root || !conf) { el = {}; return false; }
    try { cfg = JSON.parse(conf.textContent); } catch (e) { el = {}; return false; }
    el = { root: root, card: root.querySelector('.sp1-card'), form: root.querySelector('[data-sp1-form]'), input: root.querySelector('#sp1-email'), msg: root.querySelector('#sp1-msg'),
      submit: root.querySelector('[data-sp1-submit]'), art: root.querySelector('[data-sp1-art]'), duo: root.querySelector('[data-sp1-duo]'), teaser: document.querySelector('[data-sp1-teaser]') };
    el.form.addEventListener('submit', onSubmit);
    el.input.addEventListener('input', function () { if (!el.msg.hidden && isEmail(el.input.value.trim())) say(''); });
    root.addEventListener('click', onClick);
    if (el.teaser) el.teaser.addEventListener('click', onTeaser);
    return true;
  }
  if (!bind()) return;
  window.fiboliSignup = { open: open, close: close };
  if (editor) {
    var mine = function (e) { return !!(e.target && e.target.querySelector && e.target.querySelector('#signup-popup-001')); };
    var editorStep = function () { return cfg.editorStep === 'ask' && cfg.style !== 'steps' ? 'form' : cfg.editorStep; };
    document.addEventListener('shopify:section:select', function (e) { if (!mine(e)) return; st.selected = true; open(editorStep()); });
    document.addEventListener('shopify:section:deselect', function (e) { if (!mine(e)) return; st.selected = false; close(); });
    document.addEventListener('shopify:section:load', function (e) {
      if (!mine(e)) return;
      if (st.open) { st.open = false; lockPage(false); }
      if (bind() && st.selected) open(editorStep());
    });
    return;
  }
  var o = read();
  if (o.done || cfg.known) return;
  /* the cart page is for paying: no pop-up there */
  if (/\/cart\/?$/.test(location.pathname)) return;
  if (due()) {
    startClock();
    /* pick the pictures now so they load during the wait (the pop-up never opens on an empty frame) */
    var pre = function () { if (!st.open) { choosePics(); st.picked = true; } };
    if (window.requestIdleCallback) requestIdleCallback(pre, { timeout: 2000 }); else setTimeout(pre, 1000);
  } else if (o.closed) showTeaser();
})();
